import { CircleMarker, Tooltip } from "react-leaflet";
import { Sparkles } from "lucide-react";
import { recentEvents } from "@/lib/playback";
import { evDate } from "@/lib/eventDate";

export const EventPulseLayer = ({ events, pinByEntity, t, win }) => recentEvents(events, t, win)
  .filter(({ e }) => pinByEntity[e.location_entity_id])
  .slice(0, 12)
  .map(({ e, age }) => {
    const pin = pinByEntity[e.location_entity_id];
    const f = 1 - age / win;
    return (
      <CircleMarker key={`pulse-${e.id}`} center={[pin.y_coord, pin.x_coord]} radius={10 + (1 - f) * 14} interactive={false}
        pathOptions={{ color: "#F59E0B", weight: 2, opacity: 0.35 + f * 0.6, fillColor: "#F59E0B", fillOpacity: f * 0.35, className: "lf-event-pulse" }}
        eventHandlers={{ add: (ev) => ev.target.getElement()?.setAttribute("data-testid", `map-event-pulse-${e.id}`) }}>
        <Tooltip permanent direction="bottom" offset={[0, 10]} className="lf-tip lf-event-tip" opacity={0.4 + f * 0.6}>
          <span className="font-mono-lf text-[10px] opacity-70">{e.timestamp_int}</span> {e.title}
        </Tooltip>
      </CircleMarker>
    );
  });

export const PlaybackFeed = ({ events, t, win, names }) => {
  const items = recentEvents(events, t, win).slice(0, 4);
  if (!items.length) return null;
  return (
    <div className="pointer-events-none absolute top-20 left-3 sm:top-auto sm:bottom-16 sm:left-4 z-30 w-[min(320px,calc(100%-2rem))] space-y-1.5" data-testid="playback-feed">
      {items.map(({ e, age }) => (
        <div key={e.id} className="lf-feed-in rounded-md border border-[#F59E0B]/30 bg-[#13171F]/90 px-3 py-2 backdrop-blur-md"
          style={{ opacity: Math.max(0.35, 1 - age / win) }} data-testid={`playback-feed-item-${e.id}`}>
          <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-[#F59E0B]">
            <Sparkles className="h-3 w-3" />{evDate(e)}{names[e.location_entity_id] ? ` · ${names[e.location_entity_id]}` : ""}
          </div>
          <div className="truncate text-sm text-[#F3EBDD]">{e.title}</div>
        </div>
      ))}
    </div>
  );
};
